import Typography from '@mui/material/Typography';

import React from 'react';

import { toSentenceCase } from 'common/utils/utilFunctions';

import AccordionComp from '../../../common/components/Accordion/AccordionComp';

import CreateJob from './CreateJob';
import JobList from './JobList';

import styles from './JobScheduler.module.scss';

const JobScheduler = () => {
	const [expanded, setExpanded] = React.useState<string | false>('');
	const handleAccordionChange =
		(panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
			setExpanded(isExpanded ? panel : false);
		};
	return (
		<div className={styles['margin-top-main-container']}>
			<AccordionComp
				className={styles['margin-btm']}
				expanded={expanded === 'create-job'}
				onChange={handleAccordionChange('create-job')}
				summary={
					<Typography className={styles['font-weight-bold']}>
						{toSentenceCase('Create Job')}
					</Typography>
				}
				details={<CreateJob />}
			/>
			<AccordionComp
				expanded={expanded === 'job-list'}
				onChange={handleAccordionChange('job-list')}
				summary={
					<Typography className={styles['font-weight-bold']}>
						{toSentenceCase('Job List')}
					</Typography>
				}
				details={<JobList />}
			/>
		</div>
	);
};
export default JobScheduler;
